import React from 'react';

const SelectMenu = ({ options, value, onChange, name }) => (
  <select value={value || ''} onChange={e => onChange(e.target.value)}>
    {options.map(option => (
      <option
        key={`${name}-${option.value}`}
        value={option.value}
        children={option.label}
      />
    ))}
  </select>
);

export default SelectMenu;
